import {
  Box,
  Card,
  CardContent,
  Grid,
  IconButton,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import React, { Fragment, useEffect, useState } from "react";
import CheckIcon from "@mui/icons-material/Check";
import Switch from "@mui/material/Switch";
import { callBackendApi } from "../../methods/axiosInstances/backendInstance/apiRequest";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../store/snackbarSlice/snackbarSlice";

const TicketsPage = () => {
  const [tickets, setTickets] = useState([]);
  const [showResolved, setShowResolved] = useState(true);
  const dispatch = useDispatch();

  const handleShowResolvedChange = async (event) => {
    setShowResolved(event.target.checked);
    await fetchTickets(event.target.checked);
  };

  useEffect(() => {
    fetchTickets(true);
  }, []);

  const fetchTickets = async (isChecked) => {
    let response = null;
    if (isChecked) {
      response = await callBackendApi("/tickets/get-closed-tickets");
    } else {
      response = await callBackendApi("/tickets/get-open-tickets");
    }

    if (response) {
      if (response.success && response.data) {
        setTickets(response.data);
        return;
      }
      dispatch(
        showSnackbar({
          message:
            "Something happened with your request. Please contact support",
        })
      );
    }
  };

  const resolveTicket = async (ticketId) => {
    setTickets(
      tickets.map((ticket) =>
        ticket.id === ticketId ? { ...ticket, status: "CLOSED" } : ticket
      )
    );
    const response = await callBackendApi(
      `/tickets/update-status/${ticketId}`,
      "POST"
    );
    if (response.success) {
      dispatch(showSnackbar({ message: "Ticket updated!" }));
      await fetchTickets();
    }

    dispatch(
      showSnackbar({
        message: "Something happened with your request. Please contact support",
      })
    );
  };

  const columns = [
    { field: "title", headerName: "Title", flex: 1, minWidth: 150 },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
      minWidth: 300,
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: "1.5",
          }}
        >
        <img src={params.row.attachment}/>
          {params.value}
        </div>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "created_at",
      headerName: "Created At",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 100,
      renderCell: (params) => (
        <Fragment>
          <IconButton
            onClick={() => resolveTicket(params.row.id)}
            color="primary"
          >
            <CheckIcon />
          </IconButton>
        </Fragment>
      ),
    },
  ];

  return (
    <Box sx={{ width: "100%", maxWidth: "1700px", margin: "auto" }}>
      <Card>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <h1>Tickets</h1>
            </Grid>
            <Grid item xs={12}>
              <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
                <Typography>Ongoing Tickets</Typography>
                <AntSwitch
                  checked={showResolved}
                  onChange={handleShowResolvedChange}
                  defaultChecked
                  inputProps={{ "aria-label": "ant design" }}
                />
                <Typography>Closed Tickets</Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} sx={{ width: "100%" }}>
              <DataGrid
                rows={tickets}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={[10]}
                slots={{ toolbar: GridToolbar }}
                getRowHeight={() => 'auto'} // Force row height to adapt to content
                sx={{
                  width: "100%",
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#222", // Darker header for better visibility
                    color: "#fff",
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "1px solid #444",
                    display: "flex",
                    alignItems: "start",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                  },
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default TicketsPage;

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#1890ff",
        ...theme.applyStyles("dark", {
          backgroundColor: "#177ddc",
        }),
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: "rgba(0,0,0,.25)",
    boxSizing: "border-box",
    ...theme.applyStyles("dark", {
      backgroundColor: "rgba(255,255,255,.35)",
    }),
  },
}));
